import { useState, useEffect } from "react";
import Get from "../../../api/Get";
import {
  GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN,
  GET_ESPECIALIDAD_EPS,
  GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN,
} from "../../../api/Routes";
import { Card, Col, Row } from "react-bootstrap";
import Select from "react-select";
import ClbDoctorHorario from "./ClbDoctorHorario";
import Loading from "../Loading";
import userDefault from "../../../img/userdefault.png";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ClbEspecialidad = ({
  data,
  setData,
  setCurrentScreen,
  classTop = "",
}) => {
  const { t } = useTranslation();
  const [especialidad, setEspecialidad] = useState(null);
  const [especialidadesOpt, setEspecialidadesOpt] = useState([]);
  const [selectedIndexTime, setSelectedIndexTime] = useState(-1);
  const [doctorSelected, setDoctorSelected] = useState(-1);
  const [countDr, setCountDr] = useState(-1);
  const [items, setItems] = useState({
    data: null,
    currentData: null,
    doCount: true,
    loading: false,
    fetched: false,
    error: false,
    loadSchedule: true,
    refetchSchedule: true,
  });

  useEffect(() => {
    const fetchApi = async () => {
      try {
        let response;
        if (data.patient.account.id === 144) {
          response = await Get({
            url: `${GET_ESPECIALIDAD_EPS}/144?tipoPlan=${data.patient.tipoPlan}`,
            noToken: true,
          });
        } else {
          response = await Get({
            url: `${GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN}/${data.patient.account.id}`,
            noToken: true,
          });
        }
        if (response.data.state) {
          setEspecialidadesOpt(
            response.data.data.response.map((item) => ({
              label: item.name,
              value: item.id,
            }))
          );
        } else {
          setEspecialidadesOpt([]);
        }
      } catch (error) {
        setEspecialidadesOpt([]);
        console.log(error);
      }
    };
    fetchApi();
  }, []);

  useEffect(() => {
    const fecthDoctors = async () => {
      try {
        const response = await Get({
          url: `${GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN}/${especialidad.value}/${data.patient.account.id}`,
          noToken: true,
        });
        //console.log(response)
        if (response.data.state) {
          let its = response.data.data.response.map((it, index) => ({
            doctor: it.doctor,
            especialty: it.especialty,
            formation: it.formation,
            licence_number: it.licence_number,
            values: [],
          }));
          setItems((prev) => ({
            ...prev,
            data: its,
            currentData: its,
            loading: false,
            doCount: true,
          }));
          setCountDr(its.length);
        } else {
          setItems((prev) => ({
            ...prev,
            data: null,
            currentData: null,
            doCount: true,
            loading: false,
            error: true,
          }));
        }
      } catch (error) {
        setItems((prev) => ({
          ...prev,
          data: null,
          currentData: null,
          doCount: true,
          loading: false,
          error: true,
        }));
      }
    };
    if (especialidad) {
      setItems({
        data: null,
        currentData: null,
        doCount: true,
        loading: true,
        fetched: true,
        error: false,
      });
      fecthDoctors();
    }
  }, [especialidad, data.patient.account.id]);

  const selectTime = (it, i, doctor) => {
    setSelectedIndexTime(i);
    setDoctorSelected(doctor.id);
    let schedule = {
      scheduleType: "Online",
      doctor: null,
      hourInit: moment(it.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format(
        "DD-MM-YYYY HH:mm:ss"
      ),
      candidateDoctors: it.doctors.map((e) => e.id),
    };
    setData((prev) => ({
      ...prev,
      patient: {
        ...prev.patient,
        doctorId: doctor.id,
      },
      hourInit: moment(it.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format(
        "DD-MM-YYYY HH:mm:ss"
      ),
      schedule: schedule,
      doctorName: doctor.fullName,
      especialidadName: especialidad.label,
      especialidadId: especialidad.value,
    }));
  };

  const ordering = () => {
    let its = items.currentData.filter((it) => it.values.length > 0);
    its.sort((itA, itB) => {
      if (itA.values.length > 0 && itB.values.length > 0) {
        let firstAH = moment(itA.values[0].dateTimeInit, "YYYY-MM-DDTHH:mm:ss");
        let firstBH = moment(itB.values[0].dateTimeInit, "YYYY-MM-DDTHH:mm:ss");
        if (firstAH.isBefore(firstBH)) {
          return -1;
        } else {
          return 1;
        }
      } else if (itA.values.length === 0 && itB.values.length > 0) {
        return 1;
      } else if (itA.values.length > 0 && itB.values.length === 0) {
        return -1;
      } else {
        return 0;
      }
    });
    setItems((prev) => ({
      ...prev,
      data: its,
      currentData: its,
      refetchSchedule: !prev.refetchSchedule,
    }));
  };

  useEffect(() => {
    if (countDr === 0) {
      setItems((prev) => ({
        ...prev,
        doCount: false,
      }));
      ordering();
    }
  }, [countDr]);

  return (
    <Row className={classTop}>
      <Col xs="12" md={{ span: 10, offset: 1 }}>
        <Card className="mt-2 mb-5 shadow-sm">
          <Card.Body className="p-5">
            <h5 className="colorLink mb-4 text-center">
              Elige la especialidad
            </h5>
            <div className="my-3 text-center">
              <Row>
                <Col xs="12" md={{ span: 6, offset: 3 }}>
                  <Select
                    options={especialidadesOpt}
                    value={especialidad}
                    onChange={(value) => setEspecialidad(value)}
                    placeholder="Selecciona una opción"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "34px",
                        border: "1px solid #2A7EC3",
                        boxShadow: 0,
                        "&:hover": {
                          borderColor: "#2A7EC3",
                        },
                      }),
                    }}
                  />
                </Col>
              </Row>
            </div>
            {!items.fetched && (
              <div className="py-3 text-center text-danger">
                <span>{t("seleccionar_especialidad")}</span>
              </div>
            )}

            {items.fetched && (
              <div className="mt-4">
                <h5 className="colorLink mb-4 text-center">
                  Médicos disponibles
                </h5>
                {items.loading && (
                  <div className="pb-3 text-center">
                    <Loading />
                  </div>
                )}
                {!items.loading && items.error && (
                  <div className="pb-3 text-center text-danger">
                    <span>
                      No es posible obtener los doctores intenta nuevamente.
                    </span>
                  </div>
                )}
                {!items.loading && items.data.length === 0 && (
                  <div className="pb-3 text-center">
                    <span>No existen doctores disponibles.</span>
                  </div>
                )}

                {!items.loading &&
                  !items.error &&
                  items.data.length > 0 &&
                  items.data.map((it, idx) => (
                    <div
                      className="d-flex flex-column flex-md-row doctor-list mb-5"
                      key={`doctors-idx-${idx}`}
                    >
                      <div className="pr-3">
                        <img
                          src={
                            it.doctor.image ? it.doctor.image.url : userDefault
                          }
                          className="img-doctors"
                          alt="logo doctor"
                        />
                      </div>
                      <ClbDoctorHorario
                        doctor={it.doctor}
                        indexDoctor={idx}
                        data={data}
                        setData={setData}
                        items={items}
                        setItems={setItems}
                        selectTime={selectTime}
                        setCountDr={setCountDr}
                        doctorSelected={doctorSelected}
                      />
                    </div>
                  ))}
              </div>
            )}

            <div className="d-flex justify-content-center mt-2 mb-4">
              <button
                className="mr-2"
                onClick={() => setCurrentScreen("clbFormPatient")}
              >
                Regresar
              </button>
              <button
                disabled={selectedIndexTime < 0}
                onClick={() => setCurrentScreen("clbConfirmarServicio")}
              >
                Continuar
              </button>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default ClbEspecialidad;
